export default "__VITE_ASSET__DC9Vpild__"